import { Component, EventEmitter, Input, Output } from '@angular/core'
import { PropertySummary } from '../../../../state/case/case.state'
import { Observable } from 'rxjs'

@Component({
    selector: 'app-marker-clustering-selection',
    templateUrl: './marker-selection.component.html',
    styleUrls: ['./marker-selection.component.scss'],
})
export class MarkerSelectionComponent {
    private _clusteringMarkers$: Observable<PropertySummary[]>

    get markers$(): Observable<PropertySummary[]> {
        return this._clusteringMarkers$
    }

    @Input()
    set markers$(clusteringMarkers$: Observable<PropertySummary[]>) {
        this.selectedMarkers = []
        this._clusteringMarkers$ = clusteringMarkers$
    }

    name = ''

    selectedMarkers: PropertySummary[] = []

    @Output()
    selected = new EventEmitter<{ name: string; markers: PropertySummary[] }>()

    @Output()
    abort = new EventEmitter<void>()

    get canStart(): boolean {
        return !!this.name && this.selectedMarkers.length > 0
    }

    goBack(): void {
        this.abort.emit()
    }

    startJob(): void {
        if (!this.canStart) return

        this.selected.emit({ name: this.name, markers: this.selectedMarkers })
    }

    selectMarkers(markers: PropertySummary[]): void {
        this.selectedMarkers = markers
    }
}
